import { render, staticRenderFns } from "./ProductGroupSalesGraph.vue?vue&type=template&id=062cc81d&"
import script from "./ProductGroupSalesGraph.vue?vue&type=script&lang=js&"
export * from "./ProductGroupSalesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports